/**
 *
 * RouteTabWrapper
 *
 */

import React, { Suspense } from "react";
// import styled from 'styled-components';
import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import { NavLink, useRouteMatch } from "react-router-dom";
import Loader from "../Loader";
import { CustomTab, customTabMuiStyle, CustomTabs } from "./CustomTabs";
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
  },
  appbar: {
    position: "relative",
    zIndex: theme.zIndex.drawer - 1,
    marginBottom: "24px",
  },
  toolBar: {
    position: "initial",
    flexGrow: 1,
  },
  padding: {
    padding: theme.spacing(3),
  },
  activeClassName: customTabMuiStyle,
}));

export function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any,
  value: PropTypes.any,
};

function RouteTabWrapper({ children, value, tabs }) {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Box className={`${classes.appbar} ${classes.toolBar}`}>
        <CustomTabs value={value} aria-label="Tabs">
          {tabs.map((tab) => (
            // <IsAuthorised
            //   currentItem={tab.currentItem}
            //   isChild={true}
            //   requiredPermission={tab.requiredPermission}
            //   parentItem={tab.parentItem}
            // >
            <CustomTab
              component={NavLink}
              to={tab.path}
              exact={true}
              activeClassName={classes.activeClassName}
              textColor="primary"
              key={tab.path + tab.label}
              label={tab.label}
            ></CustomTab>
            // </IsAuthorised>
          ))}
        </CustomTabs>
      </Box>
      <TabPanel>
        <Suspense fallback={<Loader open />}>{children}</Suspense>
      </TabPanel>
    </div>
  );
}

RouteTabWrapper.propTypes = {
  children: PropTypes.node,
  tabs: PropTypes.array,
  value: PropTypes.number,
};

export default RouteTabWrapper;
